// When Amount-first may ask the backend for the payment method list.
//
// The fetch effect of the auto-selection hook and the tab switch (which must
// know whether a list request can still follow it) both read it from here, so
// the two cannot drift apart.

/**
 * A retry reply is stored: the player is in a retry, not in a decline recovery.
 */
export const isRetryModeOf = (resultOfPay: any): boolean => {
  const retrySettings = resultOfPay?.transaction?.retry_settings || resultOfPay?.retry_settings;

  return !!retrySettings && Object.keys(retrySettings).length > 0;
};

/**
 * The page was opened to recover a declined transaction (a one-button or an
 * alternative payment method recovery) and not as a retry.
 */
export const isOBRecoveryScenarioOf = (recoverySettings: any, isRetryMode: boolean): boolean => {
  const { ob_decline_recovery = 0, retry_with_apm = 0 } = recoverySettings || {};

  return !!(ob_decline_recovery || retry_with_apm) && !isRetryMode;
};

/**
 * True when the list request can be sent: an amount and a currency exist, the
 * page is not recovering a declined transaction, and the tab is not already
 * known to be empty.
 */
export const canRequestGatewaysOnAmountFirst = ({
  amount,
  currency,
  isOBRecoveryScenario,
  isActiveTabEmpty,
}: {
  amount: any;
  currency: any;
  isOBRecoveryScenario: boolean;
  isActiveTabEmpty: boolean;
}): boolean => !!amount && !!currency && !isOBRecoveryScenario && !isActiveTabEmpty;
